<template>
  <div :style="{width:appWidth}">
    <AppHeader/>
    <div>
      <main class="main" style="margin: 0;">
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
    </div>
    <AppFooter/>
  </div>
</template>

<script>
  import AppHeader from '../components/home/Header';
  import AppFooter from '../components/home/Footer';

export default {
  name: 'full2',
  components: {
    AppHeader,AppFooter
  },
  data(){
    return{
      appWidth : window.innerWidth>1200?window.innerWidth+"px":"1200px"
    }
  },
  created(){
    window.addEventListener('resize', this.handleResize)
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched
    }
  },
  mounted(){
    this.initStyle();
  },
  methods:{
    handleResize () {
      this.appWidth = window.innerWidth>1250?window.innerWidth+"px":"1250px";
      this.initStyle();
    },
    initStyle(){
      const width = window.innerWidth;
      const  body = $("body");
      if(width > 1250){
        body.css("overflow-x","hidden");
      }else {
        body.css("overflow-x","");
      }
    }
  }
}
</script>
<style scoped>
  .main{
    background-color: #ffffff;
    width: 100%;
  }
  .main .container-fluid {
    padding: 0;
  }
  .header-fixed .app-body{
    margin-top: 0px;
    overflow-x: scroll;
  }
</style>



// WEBPACK FOOTER //
// Full2.vue?07223c86